import React,{useState} from 'react';
import {  IconButton } from '@mui/material';
import {Typography, Box} from '@mui/material';
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import {getDocs,collection,doc, updateDoc} from "firebase/firestore"
import { db } from '../../firebaseconfig';
import Swal from "sweetalert2";
import { useAppStore } from '../../appStore';
import InputAdornment from '@mui/material/InputAdornment';

function EditCampaign({closeEvent, fid}){
    const [name, setName] = useState(fid.name);
    const [description, setDescription]=useState(fid.description);
    const [noofdays, setNoofdays]=useState(fid.noofdays);
    const [maxmemberslimit, setMaxmemberslimit]=useState(fid.maxmemberslimit);
    const [phnno, setPhnno]=useState(fid.phoneno);
    const [email, setEmail]=useState(fid.email);
    const [location, setLocation]=useState(fid.location);
    const [city, setCity]=useState(fid.city);
    const [doctorname, setDoctorname]=useState(fid.doctorname);
    const [designation, setDesignation]=useState(fid.designation);
    const [date, setDate]=useState(fid.date);
    const setCamprows = useAppStore((state)=>state.setCamprows);

    const handleNameChange = (event)=>{
        setName(event.target.value);
    }
    const handleDescriptionChange = (event)=>{
        setDescription(event.target.value);
    }

    const handleEmailChange = (event)=>{
        setEmail(event.target.value);
    }

    const handlePhnnoChange = (event)=>{
        setPhnno(event.target.value);
    }
    const handleNoofdaysChange = (event)=>{
        setNoofdays(event.target.value);
    }
    const handleMaxmemberlimitChange=(event)=>{
        setMaxmemberslimit(event.target.value)
    }
    const handleLocationChange=(event)=>{
        setLocation(event.target.value)
    }
    const handleCityChange=(event)=>{
        setCity(event.target.value)
    }
    const handleDoctornameChange=(event)=>{
        setDoctorname(event.target.value)
    }
    const handleDesignationChange=(event)=>{
        setDesignation(event.target.value)
    }
    const handleDateChange=(event)=>{
        setDate(event.target.value)
    }

    const campaignCollectionRef = collection(db,"campaigns")

    const createCampaign= async()=>{
    const campaigndoc=doc(db,"campaigns",fid.id)
         const newField= {
                name:name,
                email:email,
                phoneno:phnno,
                city:city,
                date:date,
                description:description,
                doctorname:doctorname,
                location:location,
                maxmemberslimit:maxmemberslimit,
                noofdays:noofdays,
                designation:designation
            }
            await updateDoc(campaigndoc,newField);
            getCampaigns();
            closeEvent();
            Swal.fire("Submitted", "Your file has been submitted.", "success")
        }

        const getCampaigns = async ()=>{
            const data = await getDocs(campaignCollectionRef);
            setCamprows(data.docs.map((doc)=>({...doc.data(), id:doc.id})))
          }

    return(
        <>
            <Box minWidth={500}>
            <Typography variant="h5" align="center" sx={{fontWeight:"bold",color:"#002984"}}>
                ADD CAMPAIGN
            </Typography>
            <IconButton
                style={{position:"absolute", top:"0", right:"0"}}
                onClick={closeEvent}
                >
                    <CloseIcon/>
                </IconButton>
                
                <Box height={5}/>
                <Grid container spacing={2}>
                
                    <Grid item xs={12}>
                    <TextField id="standard-basic" 
                    label="Name" 
                    variant="standard" 
                    size="small" 
                    value={name}
                    onChange={handleNameChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={12}>
                    <TextField id="standard-multiline-flexible" 
                    label="Description" 
                    variant="standard" 
                    size="small" 
                    multiline
                    maxRows={4}
                    value={description}
                    onChange={handleDescriptionChange}
                    sx={{minWidth:"100%"}} />
                    </Grid>

                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="No of days" 
                    variant="standard" 
                    size="small" 
                    value={noofdays}
                    onChange={handleNoofdaysChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="Max members limit" 
                    variant="standard" 
                    size="small" 
                    value={maxmemberslimit}
                    onChange={handleMaxmemberlimitChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>
                    
                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="Phone Number" 
                    type="number"
                    variant="standard" 
                    size="small"
                    InputProps={{
                        startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                      }}
                    value={phnno}
                    onChange={handlePhnnoChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="Date" 
                    variant="standard" 
                    size="small" 
                    value={date}
                    onChange={handleDateChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={12}>
                    <TextField id="standard-basic" 
                    label="Email Id" 
                    variant="standard" 
                    type="email"
                    size="small"
                    value={email} 
                    onChange={handleEmailChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="Location" 
                    variant="standard" 
                    type="text"
                    size="small"
                    value={location} 
                    onChange={handleLocationChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={6}>
                    <TextField id="standard-basic" 
                    label="City" 
                    variant="standard" 
                    type="text"
                    size="small"
                    value={city} 
                    onChange={handleCityChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={12}>
                    <TextField id="standard-basic" 
                    label="Doctor" 
                    variant="standard" 
                    type="email"
                    size="small"
                    value={doctorname} 
                    onChange={handleDoctornameChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>

                    <Grid item xs={12}>
                    <TextField id="standard-basic" 
                    label="Designation" 
                    variant="standard" 
                    type="email"
                    size="small"
                    value={designation} 
                    onChange={handleDesignationChange}
                    sx={{minWidth:"100%"}}/> 
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Typography varient="h5" align="center">
                        <Button variant="contained" onClick={createCampaign}>Submit</Button>
                        </Typography>
                    </Grid>     
                </Grid>
                </Box>
        </>
    )
}

export default EditCampaign;